export class DropDownFactory {
    drop:any = {}

    dropDown(){
        this.drop.id = null;
        this.drop.name = null;
        return this.drop;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/billing-letter/DropDown.factory.ts